/* eslint import/prefer-default-export: off */
export const FETCH_SUSPENSION_REASONS_SUCCESS = 'FETCH_SUSPENSION_REASONS_SUCCESS';
